import { Component, OnInit } from '@angular/core';



@Component({
  selector: 'app-request-manage',
  templateUrl: './privacy.component.html'
})
export class privacyComponent implements OnInit {
	
	constructor() { }

  ngOnInit() {
	 
  }
  
 

}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/privacy/privacy.component.ts